<template>
  <div>
    <Yukleniyor :data="loading"></Yukleniyor>
    <Kurulum :Bina_id="Bina_id" v-if="!loading & KurulumIslemi"></Kurulum> <!--  v-if="Kurulum" -->
    <Ekran :BinaBilgi="BinaBilgi" v-if="!loading & !KurulumIslemi"></Ekran>
  </div>
</template>

<script>
  import Kurulum from '../../../components/Pack/Yonetim/bina/Kurulum'
  import Ekran from '../../../components/Pack/Yonetim/bina/Ekran'
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor, Ekran, Kurulum},
    props: ["Bina_id"],
    data() {
      return {
        loading: true,
        Sayfa: {
          ButtonAdi: this.$t('eYonetim.20.1'),
          DuzenleAdi: this.$t('eYonetim.20.4'),
          SilAdi: this.$t('eGenel.11'),
          Adi: "",
          Menu: [],
        },
        BinaBilgi: {
          Durum: true,
          Online: true,
          oOdeme: true,
          Gecikme: true,
          Tolerans: 3,
          iGun: 90,
          mZam: 1,
          id: this.Bina_id,
          SGK: {
            SicilNo: null,
            Sube: null,
            Kullanici: null,
            Sifre: null,
            iSifre: null
          }
        },
        KurulumIslemi: true
      }
    },
    methods: {
      SayfaYukle() {
        /* SADECE BİNA BİLGİSİ ALINIYOR */
        this.$store.dispatch("Get", {path: 'yonetim/bina/' + this.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.KurulumIslemi = response.Bilgi.Kurulum;

              if (!this.KurulumIslemi) {
                this.BinaBilgi = response.Bilgi;
              }

              this.Sayfa.Adi = this.BinaBilgi.Adi + ' Düzenle'
              this.loading = false
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      },
    },
    created() {
      this.SayfaYukle();
      this.$store.commit("SayfaBilgi", this.Sayfa);
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Yonetim/bina/Detay.vue